// Smart Sash Admin Panel - Report Models
// Hood usage report types and interfaces

export enum HoodType {
  VAV = 'VAV',
  CAV = 'CAV',
}

export enum ComplianceLevel {
  Green = 'Green',
  Yellow = 'Yellow',
  Red = 'Red',
}

export function getComplianceLevel(score: number): ComplianceLevel {
  if (score >= 90) return ComplianceLevel.Green;
  if (score >= 70) return ComplianceLevel.Yellow;
  return ComplianceLevel.Red;
}

export interface HoodUsageSession {
  id: string;
  hoodId: string;
  hoodType: HoodType;
  userId: string;
  userName: string;
  duration: number;
  complianceScore: number;
  complianceLevel: ComplianceLevel;
  avgCfm: number | null;
  estEnergyCost: number | null;
  sessionDate: string;
  institutionId: string;
  groupId: string;
  labId: string;
  deviceId: string;
}

export interface HoodUsageFilters {
  institutionIds: string[];
  groupIds: string[];
  labIds: string[];
  userIds: string[];
  dateFrom: string | null;
  dateTo: string | null;
}

export type HoodUsageSortField =
  | 'hoodId'
  | 'hoodType'
  | 'userName'
  | 'duration'
  | 'complianceScore'
  | 'avgCfm'
  | 'estEnergyCost'
  | 'sessionDate';

export interface HoodUsageSortState {
  field: HoodUsageSortField;
  order: 'asc' | 'desc';
}

export interface HoodUsageQueryParams {
  filters: HoodUsageFilters;
  sort: HoodUsageSortState;
  page: number;
  pageSize: number;
}

export const EMPTY_HOOD_USAGE_FILTERS: HoodUsageFilters = {
  institutionIds: [],
  groupIds: [],
  labIds: [],
  userIds: [],
  dateFrom: null,
  dateTo: null,
};

export const DEFAULT_HOOD_USAGE_SORT: HoodUsageSortState = {
  field: 'sessionDate',
  order: 'desc',
};
